module.exports = __webpack_public_path__ + "95e1357cefb424dfb7170f0d1b3dd54b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/rs.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/rs.svg
// module chunks = 0